import { render, staticRenderFns } from "./ViewCertificateModal.vue?vue&type=template&id=1d1b7725"
import script from "./ViewCertificateModal.vue?vue&type=script&lang=ts"
export * from "./ViewCertificateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports